import Flickity from './flickity-player'
import 'flickity-imagesloaded'

import { debounce, toArray } from './helpers'

const ImageSlider = function () {
  let elements = []
  const instances = new Map()
  const CELL_SELECTOR = ".slide-with-caption"


  function init(elems = '[data-image-slider]') {
    elements = toArray(
      (typeof elems == 'string')
        ? document.querySelectorAll(elems)
        : elems
    )

    window.addEventListener('resize', debounce(() => {
      setTimeout(() => {
        instances.forEach(instance => {
          instance.resize()
        })
      }, 500)
    }, 500))

    elements.forEach(element => {
      let lastSlideIndex = 0
      const isWiderThanViewport = getSliderCellsLength(element) >= window.innerWidth

      instances.set(element, new Flickity(element, {
        contain: true,
        imagesLoaded: true,
        wrapAround: isWiderThanViewport,
        prevNextButtons: isWiderThanViewport,
        pageDots: isWiderThanViewport,
        draggable: isWiderThanViewport,
        autoPlay: 4000,
        cellAlign: 'left',
        on: {
          ready: function () {
            if (isWiderThanViewport) {
              positionNavigationElements(this)
              // add class with more padding for gaining space for navigation elements
              this.element.classList.add('sliding')
            }
          },
          change: function () {
            lastSlideIndex = this.selectedIndex
          }
        }
      }))
    })
  }

  /**
   * Get total length of Flickity cells
   * @param {Element} element
   * @return {Number}
   */
  function getSliderCellsLength(element) {
    const cells = Array.from(element.querySelectorAll(CELL_SELECTOR))
    return cells.reduce((total, cell) => total + cell.scrollWidth + 1, 1)
  }

  /**
   * Position the navigation elements below the slider cells
   */
  function positionNavigationElements(slider) {
    const translateX = Math.round(slider.pageDots.dots.length) * 10 + 50;
    const buttonLeft = slider.element.querySelector('button.flickity-button.flickity-prev-next-button.previous')
    const buttonRight = slider.element.querySelector('button.flickity-button.flickity-prev-next-button.next')
    buttonLeft.style.transform = 'translate(-' + translateX + 'px, -50%)'
    buttonRight.style.transform = 'translate(' + translateX + 'px, -50%)'
  }

  return {
    init,
  }
}

export default ImageSlider()
